import store from '@/store/index'

export const pageControl = (to, from, next) => {
  const { meta } = to
  const user = store.getters['auth/getUser']

  /** Verificamos se a rota possui alguma permissão, caso tenha comparamos com
   * as permissões dos grupos do usuário, caso tenha a necessária a tela é
   * liberada
   *
   * Caso o usuário seja oficial ou suporte não fazemos verificações de permissões
   */
  if (meta && meta.permissions && user && !user.flag_oficial && !user.suporte) {
    const { groups } = user

    if (groups && groups.length) {
      let access = false

      groups.forEach(group => {
        group.permissions.forEach(permission => {
          /** Verificamos as permissões da rota com o codename da permissão do
           * grupo do usuário
           */
          const per = !!meta.permissions.find(codename => codename === permission.codename)

          if (per && group.ativo) access = true
        })
      })

      /** Caso o usuário não tenha permissão para acessar o sistema, ele será
       * deslogado e continuará na tela de login
       */
      if (to.name === 'acessar_cartorio' && !access) {
        displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar o sistema.')

        store.dispatch('auth/logout')

        next('/login')
      } else if (!access) {
        displayMessage('error', 'Acesso negado!', 'Você não tem permissão para executar essa ação.')

        /** Caso o usuário esteja tentando acessar uma rota que ele não tenha
         * permissão direto pela URL, ele será redirecionado para a dashboard,
         * caso contrario ele continuará na tela que esta.
         */
        if (from === to) {
          next('/')
        } else {
          next(from.path)
        }

        throw new Error('Você não tem permissão para executar essa ação.')
      }
    } else {
      displayMessage('error', 'Acesso negado!', 'Usuário cadastrado, mas sem permissões de acesso. Peça ao Oficial ou responsável que o coloque em um Grupo de Usuários.')

      if (from === to) {
        next('/')
      } else {
        next(from.path)
      }

      store.dispatch('auth/logout')

      throw new Error('Você não tem permissão para executar essa ação.')
    }
  }

  const title = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  if (title) document.title = title.meta.title

  if (to.name === 'sinoreg_atos') {
    document.title = `${to.matched[0].meta.title} ${to.params.tipo}`
  }

  next()
}
